import { Action } from 'redux';

export const RUN_LOOKUP = 'lookup/RUN_LOOKUP';
export const RUN_NAMED_LOOKUP = 'lookup/RUN_NAMED_LOOKUP';
export const PERSIST_NAMED_LOOKUP_RESULT = 'lookup/PERSIST_NAMED_LOOKUP_RESULT';
export const PERSIST_LOOKUP_RESULT = 'lookup/PERSIST_LOOKUP_RESULT';
export const PERSIST_FETCH_LOOKUP_RECORDS = 'lookup/PERSIST_FETCH_LOOKUP_RECORDS';
export const FETCH_LOOKUP_RECORDS = 'lookup/FETCH_LOOKUP_RECORDS';

export interface RunNamedLookupAction extends Action<typeof RUN_NAMED_LOOKUP>, OnCompleteAction {
  readonly payload: {
    readonly lookup: NamedLookupRequest;
  };
}

export const runNamedLookup = (lookup: NamedLookupRequest, onComplete?: () => void): RunNamedLookupAction => ({
  meta: {
    onComplete,
  },
  payload: {
    lookup,
  },
  type: RUN_NAMED_LOOKUP,
});

export interface PersistNamedLookupResultAction extends Action<typeof PERSIST_NAMED_LOOKUP_RESULT> {
  readonly payload: {
    readonly name: NamedLookupType;
    readonly result: AggregateLookupResult;
  };
}

export const persistNamedLookupResult = (
  name: NamedLookupType,
  result: AggregateLookupResult,
): PersistNamedLookupResultAction => ({
  payload: {
    name,
    result,
  },
  type: PERSIST_NAMED_LOOKUP_RESULT,
});

export interface RunLookupAction extends Action<typeof RUN_LOOKUP>, OnCompleteAction {
  readonly payload: {
    readonly lookup: LookupRequest;
  };
}

export const runCustomLookup = (lookup: LookupRequest, onComplete?: () => void): RunLookupAction => ({
  meta: {
    onComplete,
  },
  payload: {
    lookup,
  },
  type: RUN_LOOKUP,
});

export interface PersistLookupResultAction extends Action<typeof PERSIST_LOOKUP_RESULT> {
  readonly payload: {
    readonly result: LookupResult;
  };
}

export const persistLookupResult = (result: LookupResult): PersistLookupResultAction => ({
  payload: {
    result,
  },
  type: PERSIST_LOOKUP_RESULT,
});

/**
 * Used to fetch results for provided IDs of a previous custom lookup
 */
export interface RunFetchLookupRecordsAction extends Action<typeof FETCH_LOOKUP_RECORDS>, OnCompleteAction {
  readonly payload: {
    readonly ids: ReadonlyArray<number>;
    readonly result: LookupResult;
  };
}

export const runFetchLookupRecords = (
  ids: ReadonlyArray<number>,
  result: LookupResult,
  onComplete?: () => void,
): RunFetchLookupRecordsAction => ({
  meta: {
    onComplete,
  },
  payload: {
    ids,
    result,
  },
  type: FETCH_LOOKUP_RECORDS,
});

export interface PersistFetchLookupRecordsAction extends Action<typeof PERSIST_FETCH_LOOKUP_RECORDS> {
  readonly payload: {
    readonly result: LookupResultRecordObject;
  };
}

export const persistFetchLookupRecords = (result: LookupResultRecordObject): PersistFetchLookupRecordsAction => ({
  payload: {
    result,
  },
  type: PERSIST_FETCH_LOOKUP_RECORDS,
});

export const GET_LOOKUP_OPTIONS = 'lookup/GET_LOOKUP_OPTIONS';
export interface GetLookupOptionsAction extends Action<typeof GET_LOOKUP_OPTIONS> {
  readonly payload: {
    readonly type: ClientLookupType;
  };
}

export const getLookupOptions = (type: ClientLookupType): GetLookupOptionsAction => ({
  payload: {
    type,
  },
  type: GET_LOOKUP_OPTIONS,
});

export const PERSIST_LOOKUP_OPTIONS = 'lookup/PERSIST_LOOKUP_OPTIONS';
export interface PersistLookupOptionsAction extends Action<typeof PERSIST_LOOKUP_OPTIONS> {
  readonly payload: {
    readonly options: LookupOptions;
  };
}

export const persistLookupOptions = (options: LookupOptions): PersistLookupOptionsAction => ({
  payload: {
    options,
  },
  type: PERSIST_LOOKUP_OPTIONS,
});

export const GET_LOOKUP_FIELDS_BY_REPORT_TYPE = 'lookup/GET_LOOKUP_FIELDS_BY_REPORT_TYPE';
export const getLookupFieldsByReportType = (data: any) => {
  return {
    type: GET_LOOKUP_FIELDS_BY_REPORT_TYPE,
    payload: data,
  };
};

export const RUN_LOOKUP_CUSTOM_REPORT = 'lookup/RUN_LOOKUP_CUSTOM_REPORT';
export const runLookupCustomReport = (data: any) => {
  return {
    type: RUN_LOOKUP_CUSTOM_REPORT,
    payload: data,
  };
};

export type LookupAction =
  | RunNamedLookupAction
  | PersistNamedLookupResultAction
  | PersistLookupResultAction
  | RunLookupAction
  | RunFetchLookupRecordsAction
  | PersistFetchLookupRecordsAction
  | PersistLookupOptionsAction
  | GetLookupOptionsAction;
